import { Component } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { AmplitudeService } from './services/external-tools/amplitude.service';
import { SplitIoService } from './services/external-tools/split-io.service';
import { TranslocoService } from '@jsverse/transloco';
import { TranslationService } from './services/translation.service';
import { Title } from '@angular/platform-browser';
import { take } from 'rxjs';
import { filter } from 'rxjs/operators';
import { KcResultsPollingService } from './services/learner/kc-results-polling.service';
import { FeatureFlagsService } from './services/feature-flags.service';
import { AppConstants } from './app-constants';
import { SimulationGenerationPollingService } from './services/self-serve/simulation-generation-polling.service';
import { CallRefinementPollingService } from './services/self-serve/call-refinement-polling.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  standalone: false
})
export class AppComponent {
  private previousPath = '';

  constructor(
    private router: Router,
    private amplitudeService: AmplitudeService,
    private splitService: SplitIoService,
    private translocoService: TranslocoService,
    private translationService: TranslationService,
    private titleService: Title,
    private readonly kcResultsPollingService: KcResultsPollingService,
    private readonly featureFlagsService: FeatureFlagsService,
    private simulationGenerationPollingService: SimulationGenerationPollingService,
    private callRefinementPollingService: CallRefinementPollingService
  ) {
    this.translocoService.langChanges$.subscribe((lang) => {
      document.documentElement.lang = lang;
      // this.setTranslatedTitle();
    });

    // Scroll to top only when the URL path changes, not on query-param-only navigations
    this.router.events
      .pipe(filter((e): e is NavigationEnd => e instanceof NavigationEnd))
      .subscribe((e) => {
        const currentPath = e.urlAfterRedirects.split('?')[0];
        if (currentPath !== this.previousPath) {
          this.previousPath = currentPath;
          window.scrollTo(0, 0);
        }
      });
  }

  async ngOnInit() {
    await this.translationService.loadScopedTranslation('root');
    
    // Initialize Amplitude here when the app starts, but only if the user is already authenticated.
    // Pre-auth pages (login/logout/login-callback) must not initialize third-party tracking.
    const rolesExistOnLoad = !!localStorage.getItem('roles');
    if (rolesExistOnLoad) {
      this.amplitudeService.initAmplitude();
    }

    // Initialize Split.io here when the app starts
    this.splitService.initSplit();

    const kcToastEnabled = await this.featureFlagsService.isFlagEnabled(AppConstants.KC_RESULTS_TOAST_NOTIFICATION);
    if (kcToastEnabled) {
      this.kcResultsPollingService.init();
    }

     window.addEventListener('pageshow', (event: PageTransitionEvent) => {
      const navEntry = performance.getEntriesByType(
        'navigation'
      )[0] as PerformanceNavigationTiming | undefined;
      const isBackForward =
        (event.persisted ?? false) ||
        navEntry?.type === 'back_forward';
      if (isBackForward) {
        const rolesExist = !!localStorage.getItem('roles');
        if (!rolesExist) {
          this.redirectToLogin();
        }
      }
    });
    this.simulationGenerationPollingService.init();
    this.callRefinementPollingService.init();
  }

  protected redirectToLogin(): void {
    document.documentElement.style.display = 'none';
    window.location.replace('/login');
  }

  // setTranslatedTitle() {
  //   this.translocoService
  //     .selectTranslate('QUANTIFIED_AI', {}, '')
  //     .pipe(take(1))
  //     .subscribe(val => {
  //       this.titleService.setTitle(val);
  //     });
  // }
}
